
import React, { useState } from "react";
import { useSelector } from "react-redux";
import Copy from "../../ui/iconsOld/Copy";
import classes from "./Buttons.module.css"

const CopyToCliboard = ({ text }) => {

    const [copied, setCopied] = useState(false);
    const { texts } = useSelector(state => state.translate);

    const copyToCliboard = (e) => {
        e.preventDefault()
        navigator.clipboard.writeText(text)

        setCopied(true);

        setTimeout(() => {
            setCopied(false);
        }, 1500);
    }

    return (
        <div className={classes.CopyToCliboardWrapper} onClick={(e) => copyToCliboard(e)}>
            <Copy />
            {copied ? <p className={classes.CopyLinkMessage}>{texts.copyLink}</p> : ''}
        </div>
    )
}
export default CopyToCliboard;